import { Pipe, PipeTransform }  from '@angular/core';
import { TypeActionForSpinner } from '@shared/classes/spinner';

@Pipe ({ standalone: true, name: 'spinnerIsStop' })
export class SpinnerStopPipe implements PipeTransform {
  transform (typeActionForSpinner: TypeActionForSpinner): boolean {
    return ['STOP', 'EMPTY'].includes (typeActionForSpinner);
  }
}
